import { render, staticRenderFns } from "./TaxabilityAvatax.vue?vue&type=template&id=f726cd76&scoped=true&"
import script from "./TaxabilityAvatax.vue?vue&type=script&lang=ts&"
export * from "./TaxabilityAvatax.vue?vue&type=script&lang=ts&"
import style0 from "./TaxabilityAvatax.vue?vue&type=style&index=0&id=f726cd76&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f726cd76",
  null
  
)

export default component.exports